import { ITranslation } from '../ITranslation';

export class FrenchTranslation implements ITranslation {
  public language = 'fr';
  public add = 'Ajouter';
  public dataLoadingFailureMessage = `Les données n'ont pas pu être chargées. Veuillez recharger la page.`;
  public newElement = 'Nouvel élément';
  public cancel = 'Annuler';
  public confirmDeletion = 'Voulez-vous vraiment supprimer cet objet?';
  public invalidValue = 'Veuillez entrer une valeur valide.';
  public sorting = 'Ordre';
  public sortingAscending = 'Ordre ascendant';
  public sortingDescending = 'Ordre descendant';
  public sortingThenAscending = 'Ajouter ordre ascendant';
  public sortingThenDescending = 'Ajouter ordre descendant';
  public columns = 'Columns';
  public moveColumnLeft = 'Déplacer la colonne vers la gauche';
  public moveColumnRight = 'Déplacer la colonne vers la droite';
  public hideColumn = 'Masquer la colonne';
  public showColumn = 'Afficher la colonne';
  public filter = 'Filtre';
  public equals = 'Est égal';
  public notEquals = `N'est pas égal`;
  public contains = 'Contient';
  public isEmpty = 'Est vide';
  public isNotEmpty = `N'est pas vide`;
  public before = 'Avant';
  public after = 'Après';
  public between = 'Entre';
  public yes = 'Oui';
  public no = 'Non';
  public ok = `D'accord`;
  public filterText = 'Texte du filtre';
}
